import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SubscriptionComponent } from './subscription';

export const SubscriptionModule: string = ng
    .module('subscription', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('subscription', SubscriptionComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/subscription/subscription.module.ts